import { ENV } from '@/app/config';

/**
 * Resolve a URL pública do anúncio (cardápio "Ver anúncio").
 *
 * A API devolve `buyUrl` em formatos variados: pode vir com prefixo
 * `car/`, `bike/`, `/comprar/`, sem barra inicial ou até nulo. Aqui normalizamos
 * todos os casos para produzir `${URL_BUY}<slug>` — `URL_BUY` já termina em
 * `/comprar/` em todos os ambientes (hportal/azulportal/www).
 */
const getBuyUrl = (buyUrl: string | undefined | null): string => {
	if (!buyUrl) return ENV.URL_BUY;
	const slug = buyUrl
		.replace(/^\/?(car|bike)\//i, '')
		.replace(/^\/?comprar\//i, '')
		.replace(/^\//, '');
	return `${ENV.URL_BUY}${slug}`;
};

export { getBuyUrl };
